// Firestore applies a write to the local cache (and to every listener) the moment
// it's made, but the promise it returns only settles when the SERVER acknowledges
// it. At a field with no signal that can be never, so any screen that awaits a
// write before moving on (Play Ball, End Inning, End Game...) freezes.
//
// saveLocalFirst waits briefly for the acknowledgement, so a real error on a good
// connection still reaches the caller (End Game's Retry message depends on that),
// then lets the caller move on with the write queued. Firestore uploads it when
// the connection returns; on native the queue survives an app restart because the
// cache is persistent (see firebase.ts).

const ACK_WAIT_MS = 2000;

export function saveLocalFirst(write: Promise<unknown>, label = 'write'): Promise<'synced' | 'queued'> {
  return new Promise((resolve, reject) => {
    let settled = false;
    const timer = setTimeout(() => { settled = true; resolve('queued'); }, ACK_WAIT_MS);
    write.then(
      () => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve('synced');
      },
      (err) => {
        if (!settled) {
          settled = true;
          clearTimeout(timer);
          reject(err);
        } else {
          // The caller already moved on; nobody is left to show this.
          console.error(`Queued ${label} was rejected when it synced`, err);
        }
      },
    );
  });
}
